import { GlobalAppState } from '@model/state';

export const getSeatMaps = (state: GlobalAppState) => state.seatMaps.data;
export const getSeatMapsLoading = (state: GlobalAppState) => state.seatMaps.loading;
export const getSeatMapsError = (state: GlobalAppState) => state.seatMaps.error;
export const getUnconfirmedSeats = (state: GlobalAppState) =>
  !!state.seatMaps.data?.passengerSelection && state.seatMaps.hasUnconfirmed;
